import { produce } from 'immer';

import QUICK_ORDER from 'actionTypes/quickOrder';
import { PLACE_ORDER_TYPE, SIDE } from 'constants/enums';
import { stopOrderTriggersMap } from 'constants/triggerMap';

export interface IQuickOrder {
  side: SIDE;
  orderType: PLACE_ORDER_TYPE;
  productId: number | null;
  limitPrice: number | null;
  stopPrice: number | null;
  stopTriggerMethod: keyof typeof stopOrderTriggersMap;
  size: number | null;
  quote_size: number | null;
  postOnly: boolean;
  reduceOnly: boolean;
  timeInForce: string;
  bracket_take_profit_price: number | null;
  bracket_take_profit_limit_price: number | null;
  bracket_stop_loss_price: number | null;
  bracket_stop_loss_limit_price: number | null;
  bracket_trail_amount: number | null;
  bracket_stop_trigger_method: string | null;
  cancel_orders_accepted: boolean;
  isQuickOrderModalOpen: boolean;
}

const initialState: IQuickOrder = {
  side: SIDE.BUY,
  orderType: PLACE_ORDER_TYPE.MARKET,
  productId: null,
  limitPrice: null,
  stopPrice: null,
  stopTriggerMethod: 'mark_price',
  size: null,
  quote_size: null,
  postOnly: false,
  reduceOnly: false,
  timeInForce: 'gtc',
  bracket_take_profit_price: null,
  bracket_take_profit_limit_price: null,
  bracket_stop_loss_price: null,
  bracket_stop_loss_limit_price: null,
  bracket_trail_amount: null,
  bracket_stop_trigger_method: null,
  cancel_orders_accepted: false,
  isQuickOrderModalOpen: false,
};

// eslint-disable-next-line default-param-last
const quickOrder = produce((draft: IQuickOrder = initialState, action: any) => {
  switch (action.type) {
    case QUICK_ORDER.TOGGLE_MODAL:
      Object.assign(draft, { isQuickOrderModalOpen: !draft.isQuickOrderModalOpen });
      return draft;
    case QUICK_ORDER.UPDATE:
      Object.assign(draft, action.payload);
      return draft;
    case QUICK_ORDER.RESET:
      return initialState;
    default:
      return draft;
  }
});

export default quickOrder;
